import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/sidebars/go-left.svg'


const _hoisted_1 = { class: "c-media" }
const _hoisted_2 = {
  class: "c-list-image",
  style: {"margin-left":"0px","margin-right":"5px"}
}
const _hoisted_3 = {
  key: 0,
  class: "icon-thumbnail"
}
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "icon-thumbnail mr5"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "row c-modal-select-media" }
const _hoisted_9 = { class: "left" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "right" }
const _hoisted_13 = {
  key: 0,
  class: "row animate-bottom"
}
const _hoisted_14 = {
  key: 1,
  class: "row animate-bottom p5"
}
const _hoisted_15 = { class: "wrapper-folder" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "card-folder-logo" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "card-folder-title" }
const _hoisted_20 = {
  key: 2,
  class: "row"
}
const _hoisted_21 = { class: "directory-header" }
const _hoisted_22 = { class: "txt-secondary" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = {
  key: 0,
  class: "row"
}
const _hoisted_25 = { class: "directory-card" }
const _hoisted_26 = ["value", "type", "multiple"]
const _hoisted_27 = {
  key: 1,
  class: "row animate-bottom p5 is-loading"
}
const _hoisted_28 = {
  key: 2,
  class: "col-12 mt10"
}

export function render(_ctx, _cache) {
  const _component_c_img = _resolveComponent("c-img")
  const _component_media_from_computer = _resolveComponent("media-from-computer")
  const _component_c_empty = _resolveComponent("c-empty")
  const _component_c_loading = _resolveComponent("c-loading")
  const _component_c_modal = _resolveComponent("c-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.readonly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.newValue && _ctx.newValue.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_c_img, {
                    "onUpdate:src": _ctx.onConfirmDelete,
                    src: _ctx.newValue,
                    readonly: _ctx.readonly,
                    class: _normalizeClass(["w50 h50 cover icon-media icon-radius", _ctx.class]),
                    code: "key"
                  }, null, 8, ["onUpdate:src", "src", "readonly", "class"]),
                  _createElementVNode("span", {
                    onClick: _cache[0] || (_cache[0] = $event => (_ctx.onConfirmDelete(''))),
                    class: "delete-icon"
                  }, "✕")
                ]))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.onBrowseFile && _ctx.onBrowseFile(...args))),
                  src: _ctx.uploadIcon,
                  class: "icon-media",
                  alt: ""
                }, null, 8, _hoisted_5))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.newValue && _ctx.newValue.length)
              ? (_openBlock(), _createBlock(_component_c_img, {
                  key: 0,
                  "onUpdate:src": _ctx.onConfirmDelete,
                  src: _ctx.newValue,
                  readonly: _ctx.readonly,
                  class: "w30 h30 cover icon-radius icon-media",
                  code: "key"
                }, null, 8, ["onUpdate:src", "src", "readonly"]))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.uploadIcon,
                  class: "icon-media",
                  alt: ""
                }, null, 8, _hoisted_7))
          ]))
    ]),
    _createVNode(_component_c_modal, {
      onOnClose: _ctx.onCloseBrowseFile,
      onOnConfirm: _ctx.onUpdateValue,
      labelText: "componentSelectMedia",
      active: _ctx.isModal,
      modalSize: "modal-lg",
      isText: "",
      isOverlay: ""
    }, {
      modal: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabFolders, (tab) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: tab,
                  class: "col-12",
                  style: {"float":"left"}
                }, [
                  _createElementVNode("div", {
                    onClick: $event => (_ctx.onTabChange(tab?.code)),
                    class: _normalizeClass([{'active': _ctx.activeFolder === tab?.code}, "nav-link"])
                  }, _toDisplayString(_ctx.$t(tab?.value)), 11, _hoisted_11)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.activeFolder === 'C001' && !_ctx.isDirectory?.code)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_media_from_computer, {
                    isArray: _ctx.isArr,
                    onSelectedMedia: _ctx.onSelectMediaOnly
                  }, null, 8, ["isArray", "onSelectedMedia"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.activeFolder === 'S001' && !_ctx.isDirectory?.code)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (folder) => {
                      return (_openBlock(), _createElementBlock("div", {
                        onClick: $event => (_ctx.goDirectory(folder)),
                        key: folder,
                        class: "card-folder"
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("img", {
                            src: require('@/assets/icons/sidebars/folder.svg'),
                            alt: ""
                          }, null, 8, _hoisted_18)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("span", null, _toDisplayString(folder?.title || "N/A"), 1)
                        ])
                      ], 8, _hoisted_16))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isDirectory?.code)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", null, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "bg-primary w25 h25 radius10 pointer mr10",
                        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.goBackDirectory && _ctx.goBackDirectory(...args)))
                      }),
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.isDirectory?.title) + " ", 1),
                        _createElementVNode("small", _hoisted_22, "(" + _toDisplayString(_ctx.form.code && _ctx.isArr ? _ctx.form.code.length :
                    (_ctx.form.code.length ? [_ctx.form.code].length : 0)) + ")", 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", {
                    onScroll: _cache[5] || (_cache[5] = (...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
                    ref: "listMediaBody",
                    class: "directory-list"
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      (_ctx.directoriesImage.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directoriesImage, (direct) => {
                              return (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.form.code) = $event)),
                                  value: direct.key,
                                  onChange: _cache[4] || (_cache[4] = (...args) => (_ctx.onChangeSelected && _ctx.onChangeSelected(...args))),
                                  type: _ctx.isArr ? 'checkbox' : 'radio',
                                  multiple: _ctx.isArr,
                                  class: "input-checkbox"
                                }, null, 40, _hoisted_26), [
                                  [_vModelDynamic, _ctx.form.code]
                                ]),
                                _createVNode(_component_c_img, {
                                  isOnLoading: _ctx.isDirectoryLoading,
                                  src: _ctx.$helper?.getFullImage(direct?.key),
                                  class: "detail-img"
                                }, null, 8, ["isOnLoading", "src"])
                              ]))
                            }), 256))
                          ]))
                        : (!_ctx.isDirectoryLoading && !_ctx.directoriesImage.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createVNode(_component_c_empty)
                            ]))
                          : _createCommentVNode("", true),
                      (_ctx.isDirectoryLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createVNode(_component_c_loading, { loading: true })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 544)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onOnClose", "onOnConfirm", "active"])
  ]))
}